module.exports = __webpack_public_path__ + "img/418c98f.jpg";